import React from "react";
import ReactApexChart from "react-apexcharts";
import { useFetchQueryCount } from "../../api/fetchData";
import { getCurrentIntakeQuery } from "../../utils/Dates";
import moment from "moment";
import { Skeleton, Card, CardBody, Center } from "@chakra-ui/react";

const BarReport = ({ startDate, targets, totalPotentialCount }) => {
  const courseAbbreviations = {
      "Hospitality Management [Advanced Diploma] - (Full time - 2 years)": "HM",
      "Travel & Tourism Management [Advanced Diploma] - (Full time - 1.5 years)": "TT",
      "Event Management [Diploma] - (Part time - 2 years)": "EM",
      "Commercial Cookery [Certificate IV] - (Full time - 1.5 years)": "CC",
      "Patisserie [Certificate IV] - (Full time - 1.5 years)": "PS"
  };
  const coursesFlipped = Object.assign(...Object.keys(courseAbbreviations).map(course => ({ [courseAbbreviations[course]]: course })));

  const queries = Object.assign(...Object.keys(courseAbbreviations).map(course => ({ [courseAbbreviations[course]]: `course_to_register = '${course}' AND reg_payment_confirmed_date > '${startDate}' AND reg_payment_confirmed_date <= '${moment().format('YYYY-MM-DD')}' AND ${getCurrentIntakeQuery()}` })));

  const { countHM } = useFetchQueryCount('Potentials', 'COUNT(*)', queries.HM, 'HM');
  const { countTT } = useFetchQueryCount('Potentials', 'COUNT(*)', queries.TT, 'TT');
  const { countEM } = useFetchQueryCount('Potentials', 'COUNT(*)', queries.EM, 'EM');
  const { countCC } = useFetchQueryCount('Potentials', 'COUNT(*)', queries.CC, 'CC');
  const { countPS } = useFetchQueryCount('Potentials', 'COUNT(*)', queries.PS, 'PS');

  // do not delete these commented code
  // const testQueries = Object.keys(courseAbbreviations).map(course => ({ [courseAbbreviations[course]]: `course_to_register = '${course}' AND reg_payment_confirmed_date > '${startDates[getCurrentIntakeMonth()]}' AND reg_payment_confirmed_date <= '${moment().format('YYYY-MM-DD')}'` }));
  // const testData = useFetchQueryCompletedDaysIntakeCount('Potentials', 'COUNT(*)', testQueries);

  const series = [
    {
      name: 'Registrations',
      data: [totalPotentialCount, countHM, countTT, countEM, countCC, countPS]
    },
    {
      name: 'Remaining',
      data: [
        targets.reduce((previous, current) => (previous + Number(current.targetr)), 0) - totalPotentialCount >= 0 ? targets.reduce((previous, current) => (previous + Number(current.targetr)), 0) - totalPotentialCount : 0,
        targets.length === 0 ? 0 : Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.HM).targetr) - countHM >= 0 ? Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.HM).targetr) - countHM : 0,
        targets.length === 0 ? 0 : Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.TT).targetr) - countTT >= 0 ? Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.TT).targetr) - countTT : 0,
        targets.length === 0 ? 0 : Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.EM).targetr) - countEM >= 0 ? Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.EM).targetr) - countEM : 0,
        targets.length === 0 ? 0 : Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.CC).targetr) - countCC >= 0 ? Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.CC).targetr) - countCC : 0,
        targets.length === 0 ? 0 : Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.PS).targetr) - countPS >= 0 ? Number(targets.find(({ course_to_register }) => course_to_register === coursesFlipped.PS).targetr) - countPS : 0
      ]
    }
  ];

  const options = {
    colors: [ '#4CAF50', '#A5978B' ],
    dataLabels: {
      formatter: function (val, chartOptions) {
        if ( chartOptions.seriesIndex === 0 ) {
            return `${chartOptions.config.series[chartOptions.seriesIndex].data[chartOptions.dataPointIndex]}, ${Math.round(val)}%`
        } else {
            return `${Math.round(val)}%`;
        }
      },
      style: {
          colors: [ 'white', 'black' ]
      }
    },
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      stackType: '100%',
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: [ 'Total', ...Object.values(courseAbbreviations)],
    },
    tooltip: {
      y: {
        formatter: function (val, chartData) {
          switch ( chartData.seriesIndex ) {
            case 0:
              return `${val}&nbsp;&nbsp;&nbsp;(${Math.round((val/(chartData.series[chartData.seriesIndex + 1][chartData.dataPointIndex] + val)) * 100)}%)`
            case 1:
              return `${val}&nbsp;&nbsp;&nbsp;(${Math.round((val/(val + chartData.series[chartData.seriesIndex - 1][chartData.dataPointIndex])) * 100)}%)`
            default:
              return val;
          }
        }
      }
    },
    fill: {
      opacity: 1
    
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      offsetX: 40
    },
    noData: {
      text: 'Loading...'
    }
  };

  return (
    <Card
      direction={{ base: 'column', sm: 'row' }}
      overflow='hidden'
      variant='outline'
      align='center'
      borderRadius={10}
      marginX={{ base: '5px', sm: '0px', md: '5px', lg: '5px' }}
    >
      <CardBody>
        <Center>
          <Skeleton fadeDuration={5} height='365px' isLoaded={targets && totalPotentialCount && countHM && countTT && countEM && countCC && countPS}>
            <ReactApexChart id='bar-report' options={options} series={series} type="bar" height={350} />
          </Skeleton>
        </Center>
      </CardBody>
    </Card>
  );
};

export default BarReport;